export const editorClaimList = [
    {
        title: 'unlimitedTranscription',
        apiName: 'paidFeatures:enabled',
    },
    {
        title: 'subtitleMode',
        apiName: 'editor:subtitleMode',
    },
    {
        title: 'sectionHeadingsTesting',
        apiName: 'editor:sectionHeadingsTesting',
    },
    {
        title: 'sharingToAll',
        apiName: 'sharing:all',
    },
    {
        title: 'shareAsReadOnly',
        apiName: 'share:readonly',
    },
    {
        title: 'accountActive',
        apiName: 'account:active',
    },
    {
        title: 'linkApp',
        apiName: 'services:link',
    },
    {
        title: 'transcode',
        apiName: 'services:transcode',
    },
    {
        title: 'polishTrsx',
        apiName: 'services:refiner',
    },
    {
        title: 'dataThemeApa',
        apiName: 'dataTheme:apa',
    },
    {
        title: 'signInApa',
        apiName: 'signIn:apa',
    },
    {
        title: 'keywords',
        apiName: 'keywords:enabled',
    },
    {
        title: 'abbreviations',
        apiName: 'editor:abbreviations',
    },
    {
        title: 'apiToken',
        apiName: 'account:apiToken',
    },
    {
        title: 'trashedProjects',
        apiName: 'projects:showTrashed',
    },
    {
        title: 'unlimitedStorage',
        apiName: 'unlimitedStorage:enabled',
    },
    {
        title: 'unlimitedTeamSize',
        apiName: 'unlimitedTeamSize:enabled',
    },
    {
        title: 'voiceSamplesEdit',
        apiName: 'voiceSamples:edit',
    },
    {
        title: 'voiceSamplesList',
        apiName: 'voiceSamples:list',
    },
    {
        title: 'aiTools',
        apiName: 'aitools:all',
    },
    {
        title: 'uploadAfterFail',
        apiName: 'projects:uiUploadAfterFail',
    },
    {
        title: 'accessToFailedProject',
        apiName: 'projects:accessFailedTranscriptions',
    },
    {
        title: 'retryTranscription',
        apiName: 'projects:retryTranscription',
    },
    {
        title: 'openTeam',
        apiName: 'teamProjects:enabled',
    },
    {
        title: 'openTeamCreateProjects',
        apiName: 'team:createProjects',
    },
    {
        title: 'openTeamDeleteProjects',
        apiName: 'team:deleteProjects',
    },
    {
        title: 'micTranscriptionEnabled',
        apiName: 'micTranscription:enabled',
    },
    {
        title: 'micTranscriptionDrafts',
        apiName: 'micTranscription:drafts',
    },
    {
        title: 'onPremise',
        apiName: 'onPremise:enabled',
    },
    {
        title: 'speakerIdEnabled',
        apiName: 'speakerId:enabled',
    },
];
export const subtitlesClaimList = [
    {
        title: 'srtSubtitles',
        apiName: 'subtitles:srt',
    },
    {
        title: 'vttSubtitles',
        apiName: 'subtitles:vtt',
    },
    {
        title: 'ssaSubtitles',
        apiName: 'subtitles:ssa',
    },
    {
        title: 'stlSubtitles',
        apiName: 'subtitles:stl',
    },
    {
        title: 'stlApaSubtitles',
        apiName: 'subtitles:stl_apa',
    },
    {
        title: 'ttmlSubtitles',
        apiName: 'subtitles:ttml',
    },
];
export const accountClaimList = [
    {
        title: 'subtitleMode',
        apiName: 'editor:subtitleMode',
    },
    {
        title: 'sharingToAll',
        apiName: 'sharing:all',
    },
    {
        title: 'shareAsReadOnly',
        apiName: 'share:readonly',
    },
    {
        title: 'aiTools',
        apiName: 'aitools:all',
    },
    {
        title: 'linkApp',
        apiName: 'services:link',
    },
    {
        title: 'transcode',
        apiName: 'services:transcode',
    },
    {
        title: 'polishTrsx',
        apiName: 'services:refiner',
    },
    {
        title: 'keywords',
        apiName: 'keywords:enabled',
    },
];
